(function () {
  const TOP_NAV_HEIGHT = 56;
  const PDP_NAV_HEIGHT = 56;
  const TOTAL_NAV_OFFSET = TOP_NAV_HEIGHT + PDP_NAV_HEIGHT;

  const pdpNav = document.querySelector(".pdp-nav");
  const stopPdpNav = document.getElementById("stop-pdp-nav");
  if (!stopPdpNav || !pdpNav) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY + TOTAL_NAV_OFFSET > stopPdpNav.offsetTop) {
      pdpNav.style.top = stopPdpNav.offsetTop - PDP_NAV_HEIGHT + "px";
      pdpNav.style.position = "absolute";
    } else {
      pdpNav.style.top = PDP_NAV_HEIGHT + "px";
      pdpNav.style.position = "fixed";
    }
  });
})();
